export const ACCEPTED_MAX_FILE_SIZE = 1; // MB
